import EpiComponent from '@episerver/spa-core/EpiComponent';
import OccasionalCreditCardInputBlockData from 'Models/Content/OccasionalCreditCardInputBlockData';
import React, {ReactNode, ReactNodeArray} from 'react';
import OccasionalCreditCardInputStepsManager from './OccasionalCreditCardInputStepsManager.js';

export default class OccasionalCreditCardInputBlock extends EpiComponent<OccasionalCreditCardInputBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <OccasionalCreditCardInputStepsManager context={this.getContext()} iContent={this.props.data} />;
  }
}
